import { render, staticRenderFns } from "./Change.vue?vue&type=template&id=21f5f75e"
import script from "./Change.vue?vue&type=script&lang=js"
export * from "./Change.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21f5f75e')) {
      api.createRecord('21f5f75e', component.options)
    } else {
      api.reload('21f5f75e', component.options)
    }
    module.hot.accept("./Change.vue?vue&type=template&id=21f5f75e", function () {
      api.rerender('21f5f75e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/specialists/Change.vue"
export default component.exports